import { protectedRoute } from "../config/api.config";

export function getRequests({ queryKey }) {
  const { skip, limit } = queryKey[1];
  return protectedRoute.get(`/instance/requests`, { params: { skip, limit } });
}

export function getHistory({ queryKey }) {
  const { skip, limit } = queryKey[1];
  return protectedRoute.get(`/instance/history`, { params: { skip, limit } });
}

export function instanceRequest({ id, status }) {
  return protectedRoute.patch(`/instance/request/status/${id}`, { status: status });
}

export function instanceLaunch(slug) {
  return protectedRoute.post(`/instance/launch`, { slug: slug });
}

export function getUserInstanceStatus() {
  return protectedRoute.get(`/instance/request/status`);
}

export function terminateInstance(instanceId) {
  return protectedRoute.post(`/instance/terminate`, { instanceId: instanceId });
}

export function getTerminateStatus() {
  return protectedRoute.get(`/instance/history/status`);
}

export function activeSession() {
  return protectedRoute.get(`/instance/active`);
}